/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { RolesControllerCreateMutationRequest, RolesControllerCreateMutationResponse, RolesControllerCreate400, RolesControllerCreate401, RolesControllerCreate403, RolesControllerCreate409 } from "../../models/rolesController/RolesControllerCreate";

function getRolesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/roles` as const }  
  return res
}

/**
 * @summary Create a custom role
 * {@link /api/v1/roles}
 */
export async function rolesControllerCreate(data?: RolesControllerCreateMutationRequest, config: Partial<RequestConfig<RolesControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<RolesControllerCreateMutationResponse, ResponseErrorConfig<RolesControllerCreate400 | RolesControllerCreate401 | RolesControllerCreate403 | RolesControllerCreate409>, RolesControllerCreateMutationRequest>({ method : "POST", url : getRolesControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}